import saMessages from '../locales/ar_AR.json';
import arEG from 'antd/locale/ar_EG';

const arLang = {
  messages: {
    ...saMessages,
  },
  antLocale: arEG,
  locale: 'ar',
};
export default arLang;
